export const environment = {
  production: true,
  mock: false,
  serviceUrl: 'https://cm-dashboard-be.consumable.com',
  publisherApiUrl: ' https://publisher-api.consumable.com'
};
